import type { ReactNode } from "react";
import type { Verdict } from "@patent-studio/api-types";
import { Circle, CircleCheck, CircleDashed, Contrast } from "lucide-react";
import { StatusPill } from "@/components/ui/StatusPill";
import { VERDICT_LABELS, VERDICT_TONE } from "@/lib/verdict-labels";

/** The glyph the design's chip draws before each verdict: whole, half or empty. */
const GLYPH: Record<Verdict, ReactNode> = {
  novel: <CircleCheck aria-hidden />,
  partially_novel: <Contrast aria-hidden />,
  not_novel: <Circle aria-hidden />,
  not_assessed: <CircleDashed aria-hidden />,
};

/**
 * The one badge a row carries: the served verdict, in its tint. A badge in a
 * list of findings, or the design's chip beside a row's controls.
 */
export function VerdictBadge({
  verdict,
  size = "badge",
}: {
  verdict: Verdict;
  size?: "badge" | "chip";
}) {
  const chip = size === "chip";
  return (
    <StatusPill
      tone={VERDICT_TONE[verdict]}
      data-testid="verdict-badge"
      data-verdict={verdict}
      size={chip ? "chip" : "md"}
      plain={chip}
      {...(chip ? { icon: GLYPH[verdict] } : { dot: true })}
    >
      {VERDICT_LABELS[verdict]}
    </StatusPill>
  );
}
